class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      header: "#shopify-section-header",
      announcement: "#shopify-section-announcement"
    };
  }

  connectedCallback() {
    this.header = document.querySelector(this._selectors.header);
    this.announcement = document.querySelector(this._selectors.announcement);

    if (!this.header) {
      console.error('Header element not found!');
      return;
    }

    this._setVariables();
    this._watchWindowResize();
    this._watchScroll();
  }

  _watchWindowResize = () => {
    window.addEventListener('resize', this._setVariables);
  }

  _setVariables = () => {

    this.headerHeight = this.header.clientHeight;
    this.announcementHeight = this.announcement ? this.announcement.clientHeight : 0;

    this.stickyThreshold = this.announcementHeight;
  }

  _watchScroll = () => {
    window.addEventListener('scroll', this._checkScroll);
  }

  _checkScroll = () => {
    if (window.scrollY > this.stickyThreshold) {
      this.header.classList.add('header--scrolled');
      document.body.style.paddingTop = `${this.headerHeight}px`;
    } else {
      this.header.classList.remove('header--scrolled');
      document.body.style.paddingTop = '0px'; 
    }
  }
}

customElements.define("s-header", SiteHeader);
